var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-checkbox',{staticClass:"cc-switch",attrs:{"id":_vm.id,"switch":"","size":"lg","disabled":_vm.disabled,"checked":_vm.value},on:{"change":_vm.onCheckboxClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }